import { AnyAction } from 'redux';
import { NThunkAction } from 'state/types';
import { getContextOrganization } from 'state/selectors-global';
import { PricingPlan } from '@neptune/shared/core-organizations-domain';
import { isV3Pricing, isV4Pricing } from '@neptune/shared/organization-business-logic';
import {
  changePlanModalName,
  v3ChangePlanModalName,
  v4ChangePlanModalName,
} from '@neptune/pricing-commons-domain';
import { hideGenericModal, showGenericModal } from 'state/ui/modals/generic/actions';

export function openChangePlanModal(): NThunkAction<void, AnyAction> {
  return async (dispatch, getState) => {
    const organization = getContextOrganization(getState());
    const modalName = getModalName(organization?.pricingPlan);
    dispatch(showGenericModal(modalName));
  };
}

export function closeChangePlanModal(): NThunkAction<void, AnyAction> {
  return async (dispatch, getState) => {
    const organization = getContextOrganization(getState());
    const modalName = getModalName(organization?.pricingPlan);
    dispatch(hideGenericModal(modalName));
  };
}

function getModalName(pricingPlan: PricingPlan | undefined): string {
  if (isV3Pricing(pricingPlan)) {
    return v3ChangePlanModalName;
  }

  if (isV4Pricing(pricingPlan)) {
    return v4ChangePlanModalName;
  }

  return changePlanModalName;
}
